/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { setupCache } from "axios-cache-adapter";

import "./styles.scss";
import { Globe } from "./components/Globe/globe";
import { Hosts } from "./components/Hosts/hosts";
import { Landing } from "./components/Landing/landing";
import { Videos } from "./components/Videos/videos";
import { Lineup } from "./components/Lineup/lineup";
import { Sponsors } from "./components/Sponsors/sponsors";
import { Team } from "../Teams/teams";
import { Sessions } from "./components/Sessions/sessions";
import { PreviousSessions } from "./components/PreviousSessions";

export const MainPage = (): JSX.Element => {
  const { pathname } = useLocation();
  const [teams, setTeams] = useState<Team[]>([]);
  const cache = setupCache({
    maxAge: 15 * 60 * 1000,
  });
  const api = axios.create({
    adapter: cache.adapter,
  });
  useEffect(() => {
    if (pathname === "") {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  useEffect(() => {
    api
      .get("https://api.igem.io/api/openingWeekend/teamData")
      .then((value) => setTeams(value.data.data))
      .catch(() => {});
  }, []);
  return (
    <div className="main-page">
    <Landing />
    <Sessions />
    <PreviousSessions />
      <Globe teams={teams} />
      <Videos />
      <Hosts />
      <Lineup />
      <Sponsors />
    </div>
  );
};
